module.exports = __webpack_public_path__ + "img/ao.9f5faa91.png";